import { useMemo } from "react";

const ignores = ["www", "noella-unvivid-suzy"];
export default function useSubdomain(level = 0) {
  return useMemo(() => {
    // 1. Get the current hostname (e.g., "://muciifidev.com")
    const hostname = window.location.hostname;

    // 2. Split the domain into an array of words: ["k", "muciifidev", "com"]
    const parts = hostname.split(".");

    // 3. Define your base domain length.
    // "muciifidev.com" has exactly 2 parts.
    const baseDomainLength = 2;

    // 4. Calculate where the subdomains start by removing the base parts
    // For ["k", "muciifidev", "com"], the subdomains array becomes just ["k"]
    const subdomains = parts.slice(0, parts.length - baseDomainLength);

    // 5. Reverse the array so we can count levels from right to left:
    // Level 0 is the closest to the domain name.
    const reversedSubdomains = subdomains.reverse();

    // 6. Return the requested subdomain level, or null if it doesn't exist
    let esubdomain = reversedSubdomains[level] || null;
    if (esubdomain && ignores.includes(esubdomain)) esubdomain = null;
    return esubdomain;
  }, [level]);
}
